export default "__VITE_ASSET__DvRWlw$I__"